const EVENT = {
  UNAUTHORIZED: 'UNAUTHORIZED'
}

let subscribers = {}

export default {
  publish (event, data) {
    if (!subscribers[event]) {
      return
    }
    subscribers[event].forEach(subscriberCallback => subscriberCallback(data))
  },
  subscribe (event, callback) {
    if (!subscribers[event]) {
      subscribers[event] = []
    }
    subscribers[event].push(callback)
  },
  EVENT
}
